const URL: string = "https://api-iggy.1ath.studio/api/v1/main/";

export const GET_NONCE: string = URL + "get-nonce";
export const LOGIN: string = URL + "login";
export const GET_NOMINEE: string = URL + "get-nominee";
export const GET_ADDRESS_BY_NOMINEE: string = URL + "get-address-by-nominee";
export const VOTE: string = URL + "vote";